import {
  Box,
  Loader,
  Center,
  Button,
  Flex,
  Grid,
  Input,
  Paper,
  Select,
  Text,
  Title,
  createStyles,
  Image,
} from "@mantine/core";

import paymentSvg from "../../assets/img/payment.svg";
import { DynamicForm } from "./DynamicForm";
import { useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { availityBotHandler } from "./Service";
import CustomBreadcrumbs from "../../components/CustomBreadCrumbs";
import { ServiceTag } from "../Eligibility/ServiceTag";
import { showNotification } from "@mantine/notifications";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    margin: "16px 40px",
    height: "100%",
    padding: "16px",
  },
  loader: {
    marginTop: "40px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  breadCrumbs: {
    marginBottom: "16px",
    justifyContent: "space-between",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  title1: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",

    // marginLeft: "50px",
  },

  heading: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  imageBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  imageBoxParent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  alignCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
}));

export const AvailityForm = () => {
  const { classes } = useStyles();
  const medplum = useMedplum();

  const [isFetching, setIsFetching] = useState(false);
  const [payers, setPayers] = useState<any>([]);
  const [selectedPayer, setSelectedPayer] = useState(null);
  const [form, setform] = useState<any>([])

  const fetchPayers = async () => {
    try {
      const res = await medplum.searchResources("Organization");
      const filteredPayers = res
        .filter((item) =>
          item?.identifier?.some((id) => id?.system?.includes("availity"))
        )
        .map((item) => ({
          label: item.name,
          value: item.id,
        }));
      setPayers(filteredPayers);
    } catch (error) {
      console.error("Error fetching payers:", error);
    }
  };

  const fetchFormForSelectedPayer = async () => {
    try {
      setIsFetching(true)
      const response = await availityBotHandler(medplum, {
        request: "configurations",
        params: { type: 'service-review', payerId: selectedPayer },

      })
      if (!response) {
        showNotification({
          color: "red",
          message: "Failed to fetch form!please try again",
          autoClose: true,
        });
      }
      // setIsFetching(false)
      setform(response.configurations)
    } catch (error) {
      console.error("Error fetching form:", error);
      setIsFetching(false)
    } finally {
      setIsFetching(false)
    }
  };

  useEffect(() => {
    fetchPayers();
  }, []);

  useEffect(() => {
    if (selectedPayer) {
      fetchFormForSelectedPayer();
    }
  }, [selectedPayer]);

  return (
    <>
      {isFetching ? (
        <Center className={classes.loader}>
          <Loader />
        </Center>
      ) : (
        <Paper className={classes.default}>
          {!selectedPayer ? (
            <>
              <Box className={classes.breadCrumbs}>
                <CustomBreadcrumbs />
                <ServiceTag serviceType={"availity"} />
              </Box>
              <Title className={classes.title1}>
                Prior Auth
              </Title>
              <Box
                className={classes.imageBoxParent}
                sx={(theme) => ({
                  padding: theme.spacing.md,
                  [theme.fn.smallerThan("md")]: {
                    padding: theme.spacing.sm,
                  },
                })}
              >
                <Box className={classes.imageBox}>
                  <Box
                    sx={(theme) => ({
                      marginBottom: theme.spacing.md,
                      width: "100%",
                      maxWidth: "500px",
                      [theme.fn.smallerThan("sm")]: {
                        maxWidth: "150px",
                      },
                    })}
                  >
                    <Image src={paymentSvg} alt="Payment illustration" />
                  </Box>
                  <Title order={4} align="center" mb="md">
                    Please select a payer to proceed
                  </Title>
                </Box>

                <Box
                  sx={(theme) => ({
                    width: "50%",
                    [theme.fn.smallerThan("md")]: {
                      width: "70%",
                    },
                    [theme.fn.smallerThan("sm")]: {
                      width: "90%",
                    },
                  })}
                >
                  <Select
                    label="Select Payer"
                    placeholder="Select Payer"
                    size="md"
                    value={selectedPayer}
                    onChange={(e) => {
                      setSelectedPayer(e as any);
                    }}
                    data={payers}
                  />
                </Box>
              </Box>
            </>
          ) : (
            <>
              <Box className={classes.breadCrumbs}>
                <CustomBreadcrumbs />
                <ServiceTag serviceType={"availity"} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Box className={classes.alignCenter}>
                  <Title mt={4} className={classes.title1}>
                    Prior Auth
                  </Title>
                </Box>
                <Select
                  label="Select Payer"
                  placeholder="Select Payer"
                  size="md"
                  value={selectedPayer}
                  onChange={(e) => {
                    setSelectedPayer(e as any);
                  }}
                  data={payers}
                />
              </Box>
              <DynamicForm configurations={form} setLoader={setIsFetching} payerId={selectedPayer} />
            </>
          )}
        </Paper>
      )}
    </>
  );
};
